import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Image as ImageIcon, FileSignature, MessageSquareText, Calculator, Sparkles, Palette } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    num: '1',
    icon: <ImageIcon className="w-5 h-5 text-brand-black" data-id="element-14" />,
    title: '100 Historias listas para subir',
    desc: 'Plantillas de Venta, Educación y Testimonios para no pensar qué publicar.'
  }, {
    num: '2',
    icon: <Palette className="w-5 h-5 text-brand-black" data-id="element-15" />,
    title: 'Plantillas de Canva editables',
    desc: 'Diseños profesionales adaptables a los colores de tu estética.'
  }, {
    num: '3',
    icon: <FileSignature className="w-5 h-5 text-brand-black" data-id="element-16" />,
    title: 'Kit de Consentimientos Legales',
    desc: 'Documentos listos para imprimir y protegerte legalmente.'
  }, {
    num: '4',
    icon: <MessageSquareText className="w-5 h-5 text-brand-black" data-id="element-17" />,
    title: 'Scripts de WhatsApp comprobados',
    desc: 'Respuestas listas para precio, demoras y reclamos. Cerrá ventas sin trabarte.'
  }, {
    num: '5',
    icon: <Calculator className="w-5 h-5 text-brand-black" data-id="element-18" />,
    title: 'Calculadora de Precios Anti-Inflación',
    desc: 'Planilla en Excel para actualizar tus precios automáticamente cada mes.'
  }, {
    num: '6',
    icon: <Sparkles className="w-5 h-5 text-brand-black" data-id="element-19" />,
    title: 'Guía de Tendencias 2026',
    desc: 'Los servicios y técnicas que más van a facturar este año en Argentina.'
  }];
  return <section className="py-20 bg-[#050505] border-y border-white/5" data-id="element-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-22">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-pink/10 mb-6" data-id="element-23">
            <Gift className="w-8 h-8 text-brand-pink" data-id="element-24" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-25">
            🎁 BONOS EXCLUSIVOS{' '}
            <span className="text-brand-pink italic" data-id="element-26">(INCLUIDOS HOY)</span>
          </h2>
        </motion.div>

        <div className="flex flex-col gap-4" data-id="element-27">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col sm:flex-row items-start sm:items-center gap-6 bg-brand-black p-6 rounded-2xl border border-white/10 hover:border-brand-pink/30 transition-colors" data-id="element-28">
              <div className="flex-shrink-0" data-id="element-29">
                <div className="bg-brand-pink text-brand-black font-bold px-4 py-2 rounded-full text-sm flex items-center gap-2" data-id="element-30">
                  {bono.icon}
                  BONO #{bono.num}
                </div>
              </div>
              <div data-id="element-31">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-32">
                  {bono.title}
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-33">{bono.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}